import React, { useContext, useEffect, useState } from "react";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import axios from "axios";
import { AppContext } from "../context/AppContext";

const OfferModule = () => {
  const { notifySuccess } = useContext(AppContext);
  const { url, user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const getData = async () => {
    try {
      const token = await dispatch(getToken());
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/Settlement_Offers`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 200) {
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getData();
    }
  }, [user]);
  //
  const acceptReject = async (type, id) => {
    try {
      const token = await dispatch(getToken());
      const data = [
        {
          Client_Approval: type,
          Lead_Name: user.id,
        },
      ];
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v8/Settlement_Offers/${id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 201) {
        notifySuccess(`Offer ${type}`);
        getData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Title title={"Settlement Offer Module"} />

      <>
        {data.length === 0 ? (
          <p className="text-center py-4">No data found</p>
        ) : (
          data.map((item, index) => {
            return (
              <div className="mt-2" key={index}>
                <p className="fw-bold mb-2">Settlement Offer {index + 1}</p>
                <div className="offer-module-grid">
                  <div className="offer-module-card">
                    <p>Lead Name</p>
                    <p className="fw-bold">{item.Lead_Name?.name}</p>
                  </div>
                  <div className="offer-module-card">
                    <p>Creditor Name</p>
                    <p className="fw-bold">{item.Creditor_Name?.name}</p>
                  </div>
                  <div className="offer-module-card">
                    <p>Balance Outstanding</p>
                    <p className="fw-bold">
                      Rs {item.Balance_Outstanding.toLocaleString("en-IN")}
                    </p>
                  </div>
                  <div className="offer-module-card">
                    <p>Offer Amount</p>
                    <p className="fw-bold">
                      Rs {item.Offer_Amount.toLocaleString("en-IN")}
                    </p>
                  </div>
                  <div className="offer-module-card">
                    <p>Waiver</p>
                    <p className="fw-bold">{item.Waiver}%</p>
                  </div>
                  {item.Client_Approval !== null ? (
                    <div className="offer-module-card">
                      <p>Client Approval</p>
                      <p
                        className={`fw-bold ${item.Client_Approval.toLowerCase() === "accepted" ? "text-success" : "text-danger"}`}
                      >
                        {item.Client_Approval}
                      </p>
                    </div>
                  ) : (
                    <div className="d-flex align-items-end justify-content-end gap-2">
                      <button
                        className="button"
                        onClick={() => acceptReject("Accepted", item.id)}
                      >
                        Accept
                      </button>
                      <button
                        className="red-button"
                        onClick={() => acceptReject("Rejected", item.id)}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </div>
                {index !== data.length - 1 && <hr />}
              </div>
            );
          })
        )}
      </>
    </>
  );
};

export default OfferModule;
